import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { IEmergencyTreatmentReport } from "../../../models/IEmergencyTreatment";
import { dateTimeToDateString } from '../../../helpers/DateHelper';

interface IEmergencyTreatmentReportInfo {
    emergencyTreatment?: IEmergencyTreatmentReport;
}

export const EmergencyTreatmentReportInfo: React.FunctionComponent<IEmergencyTreatmentReportInfo> = ({ emergencyTreatment }) => {

    return (
        <div className="row">
            <div className="col-6">
                <TextInput name="dateOfTreatment" label="Behandlingsdatum" defaultValue={dateTimeToDateString(emergencyTreatment?.dateOfTreatment)} readonly inlineLabel />
            </div>
            <div className="col-6">
                <TextInput name="status" label="Status" defaultValue={emergencyTreatment?.status} readonly inlineLabel />
            </div>
        </div>
    );
}